<template>
  <base-dialog
    :action="onAction"
    :action-name="hasDiscount ? 'Change coupon' : 'Add a coupon'"
    :close="onClose"
    :title="hasDiscount ? 'Change coupon' : 'Add coupon'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="filter"
            label="Search"
            class="mb-3"
            prepend-inner-icon="search"
            block
            outlined
            hide-details
            clearable
          />

          <v-alert
            dense
            outlined
            text
            color="info"
            icon="info"
          >
            Only showing coupons with matching currency:
            ({{ currency() }} - {{ currencyName() }}).
          </v-alert>

          <v-list>
            <v-list-item-group v-model="selectedCoupon">
              <template v-for="(coupon, index) in list">
                <v-list-item
                  :key="`coupon_${index}`"
                  :value="coupon.id"
                  :disabled="!coupon.valid || coupon.id === currentCoupon"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ coupon.name }} <span class="grey--text caption">({{ coupon.id }})</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ terms(coupon) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip
                      v-if="!coupon.valid && coupon.id !== currentCoupon"
                      small
                      color="error"
                      outlined
                    >
                      Expired
                    </v-chip>

                    <v-chip
                      v-if="coupon.id === currentCoupon"
                      small
                      color="info"
                      outlined
                    >
                      Current
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import BaseDialog from "@/components/Common/BaseDialog"
import { readableCouponTerms } from "../../services/stripe.service"

export default {
  components: { BaseDialog },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
    currentCoupon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: '',
      selectedCoupon: null,
      coupons: [],
      filter: ''
    }
  },
  computed: {
    ...mapGetters([ 'getCoupons' ]),
    hasDiscount() {
      return !isEmpty(this.customer.discount)
    },
    list() {
      const regex = new RegExp(this.filter, 'i')
      return isEmpty(this.filter)
        ? this.getCoupons
        : this.getCoupons.filter(c => c.name.match(regex))
    }
  },
  async mounted() {
    const payload = {}

    // Coupons are stored in state
    await this.listCoupons(payload)
  },

  methods: {
    ...mapActions([ 'updateCustomer', 'listCoupons' ]),
    onClose() {
      this.$emit('close')
    },
    terms(coupon) {
      return readableCouponTerms(coupon)
    },
    currency() {
      return this.customer.currency
    },
    currencyName() {
      return 'CURRENCY NAME'
    },
    async onAction() {
      const payload = {
        id: this.customer.id,
        coupon: this.selectedCoupon
      }

      const customer = await this.updateCustomer(payload)

      this.$emit('action', customer)
    }
  }
}
</script>
